var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"log",rawName:"v-log",value:({
        type: 'show',
        name: 'ADSENSE',
        value: {
            type: _vm.googleStyle,
        },
    }),expression:"{\n        type: 'show',\n        name: 'ADSENSE',\n        value: {\n            type: googleStyle,\n        },\n    }"}],staticClass:"slider-guide-container"},[_c('img',{staticClass:"slider-icon",attrs:{"src":_vm.SlideGuideArrow}}),_vm._v(" "),(_vm.showCountDown)?_c('div',{staticClass:"slider-tip"},[_vm._v(_vm._s(_vm.countDownRef))]):_c('div',{staticClass:"slider-tip"},[_vm._v(_vm._s(_vm.defaultTipsRef))])])
}
var staticRenderFns = []

export { render, staticRenderFns }